// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type LinkIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from link.svg
 */
export default function LinkIcon(props: LinkIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="LinkIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M15.004 6.108c1.412-1.466 1.29-3.735-.152-5.073-1.45-1.346-3.88-1.415-5.406 0l-.09.095L8.3 2.404l-.074.101a1 1 0 0 0 .205 1.307l.102.074a1 1 0 0 0 1.306-.205l1.005-1.211.091-.076c.748-.573 1.896-.507 2.558.107.66.613.694 1.645 0 2.29l-.08.082-3.077 3.592c-.805.723-1.856.713-2.655-.028a1 1 0 0 0-1.36 1.466c1.576 1.463 3.83 1.463 5.406 0l.06-.06 3.118-3.638zM9.733 7.51a1 1 0 0 0-.053-1.413c-1.576-1.463-3.83-1.463-5.406 0l-.08.082-3.099 3.615-.099.098c-1.412 1.466-1.29 3.735.152 5.073 1.45 1.346 3.88 1.415 5.406 0l.09-.095L7.7 13.596l.074-.101a1 1 0 0 0-.205-1.307l-.102-.074a1 1 0 0 0-1.306.205l-1.006 1.21-.09.077c-.748.573-1.896.507-2.558-.107a1.544 1.544 0 0 1 0-2.29l.08-.082 3.077-3.592c.805-.723 1.856-.713 2.655.028a1 1 0 0 0 1.413-.053"
        />
      </g>
    </svg>
  );
}
